import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.data;

export const dataSelectors = {
  menus: createSelector(selector, (state) => state.menus),
  maintenance: createSelector(selector, (state) => state.maintenance),
  registrationResults: createSelector(
    selector,
    (state) => state.registrationResults,
  ),
};
